import { render, staticRenderFns } from "./TimesAndAddr.vue?vue&type=template&id=035ec308&"
import script from "./TimesAndAddr.vue?vue&type=script&lang=ts&"
export * from "./TimesAndAddr.vue?vue&type=script&lang=ts&"
import style0 from "./TimesAndAddr.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports